import './index.scss';

import React from 'react';

interface IChartNotFoundProps {
  text: string;
  /** Without the handler the control shows only the text. */
  onRetry?: () => void;
}

const ChartNotFound: React.FC<IChartNotFoundProps> = ({ text, onRetry }) => {
  return (
    <div className="mm-pair-chart-not-found">
      <span className="caption">{text}</span>
      {onRetry && (
        <button
          type="button"
          className="mm-pair-chart-not-found__retry"
          onClick={onRetry}
          data-testid="chart-retry"
        >
          Retry
        </button>
      )}
    </div>
  );
};

export { ChartNotFound };
